import { TZDate } from "@date-fns/tz";

const TRAILING_OFFSET_PATTERN = /(?:Z|([+-])(\d{2}):?(\d{2}))$/;
const UTC_OFFSET = "+00:00";

/**
 * Parses an ISO-8601 datetime string into a date pinned to the string's own
 * UTC offset, so date-fns formatting and calendar math show the wall-clock
 * time at the source location rather than the browser's. A string without an
 * offset is read as UTC. Date instances pass through unchanged (local time);
 * any other input yields an Invalid Date.
 *
 * @param {string | Date} value
 * @returns {Date}
 */
export function parseOffsetDateTime(value) {
  if (value instanceof Date) {
    return value;
  }

  if (typeof value !== "string" || value === "") {
    return new Date(NaN);
  }

  const match = value.match(TRAILING_OFFSET_PATTERN);

  if (!match) {
    const normalized = value.includes("T") ? `${value}Z` : value;

    return new TZDate(normalized, UTC_OFFSET);
  }

  const [, sign, hours, minutes] = match;
  const offset = sign ? `${sign}${hours}:${minutes}` : UTC_OFFSET;

  return new TZDate(value, offset);
}
